// extracted by mini-css-extract-plugin
export var columnList = "_ft-0";